export const environment =
{
    production: false,
    betaTest: true,

    CalipoliUrl: 'https://test.calipoli.com/mypage',
    API_URL: 'https://apitest.calipoli.com'
}
